export default __webpack_public_path__ + "static/media/tms-portabella-4000i.ac9c97e0.webp";